import { RootState } from "../index";

export const globalSelector = (state: RootState) => state.global;
